import { render, staticRenderFns } from "./PartnerBookings.vue?vue&type=template&id=24ab0ef8&scoped=true"
import script from "./PartnerBookings.vue?vue&type=script&lang=js"
export * from "./PartnerBookings.vue?vue&type=script&lang=js"
import style0 from "./PartnerBookings.vue?vue&type=style&index=0&id=24ab0ef8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ab0ef8",
  null
  
)

export default component.exports